export default "__VITE_ASSET__00e38eeb__"